module.exports = __webpack_public_path__ + "img/pethouse46.744580d2.jpg";